import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import styles from "../hik.module.css";

const KdProModular = () => {
  const { t } = useTranslation(); // استخدم i18next للترجمة
  return (
    <motion.div
      className={styles.productDetails}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <motion.div
        className={styles.productImage}
        initial={{ x: -200 }}
        animate={{ x: 0 }}
        transition={{ type: "spring", stiffness: 100 }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/05-hikvision/cam/intercom/details/KdmProModular/01.jpg`}
          alt={t("kdProModular.altText")} // استخدم الترجمة للنص البديل
        />
      </motion.div>
      <motion.div
        className={styles.productInfo}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.h1
          className={styles.productTitle}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          {t("kdProModular.title")}
        </motion.h1>
        <motion.ul className={styles.productFeatures}>
          {Array.from({ length: 9}, (_, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4 + index * 0.2, duration: 0.6 }}
            >
              {t(`kdProModular.feature${index + 1}`)}
            </motion.li>
          ))}
        </motion.ul>
      </motion.div>
    </motion.div>
  );
};

export default KdProModular;
